import React from "react";

const items = [
  { icon: "🔒", text: "100% Confidential Service" },
  { icon: "🎓", text: "Trusted by Scholars Nationwide" },
  { icon: "⏱️", text: "On-Time Delivery Guaranteed" },
  { icon: "⚡", text: "Limited-Time 30% Off + Free Consultation" },
];

export default function TrustStrip() {
  return (
    <div className="trust-strip">
      <div className="wrap">
        {items.map((item) => (
          <div className="trust-item" key={item.text}>
            <span className="ico">{item.icon}</span> {item.text}
          </div>
        ))}
      </div>
    </div>
  );
}
